"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M14.874 2.567c.079-.545-.652-.799-.928-.322L8.434 11.77a.5.5 0 0 0 .433.75h1.548l-1.29 8.912c-.078.545.653.799.929.322l5.512-9.526a.5.5 0 0 0-.433-.75h-1.548l1.289-8.912v.001Z"
  })]
});